import script from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTable.vue?vue&type=style&index=0&id=0000f2f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0000f2f0"]])

export default __exports__